module.exports = __webpack_public_path__ + "img/194f5a505232abd82d5db56a4703e55e.png";